import Loadable from 'react-loadable';

import { SpinnerSmall } from 'components/visual/Spinner';

export const PdfViewer = Loadable({
  loader: () => import('./viewer'),
  loading: () => <SpinnerSmall />,
  render(loaded, props) {
    const { PdfViewer: PdfViewerComponent } = loaded;
    return <PdfViewerComponent {...props} />;
  },
});
